import { Component } from "@angular/core";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "unauthorized",
    templateUrl: "./unauthorized.component.html",
    standalone: false
})
export class UnauthorizedComponent {
    constructor(private authService: AuthService) {
        authService.accessToken = null;
    }
}